<div class="p-8 pb-0 bg-[#F3F4F4] flex flex-wrap md:flex-nowrap gap-4 relative">
  <div class="sidebar">
    <p-card styleClass="h-full">
      <div class="flex flex-col">
        <div class="px-2">
          <div *ngIf="project() && project().Name; else loading" class="flex justify-between items-center px-3">
            <img
              *ngIf="hasProjectLogo()"
              [src]="project().ProjectLogo"
              [alt]="project().Name + ' logo'"
              class="max-h-14 w-auto object-contain"
              (error)="onImageError($event)" />
            <span class="text-xl pl-1 justify-center items-center" *ngIf="!hasProjectLogo()">{{ project().Name }}</span>
            <button *ngIf="showRefreshButton()" (click)="onRefreshPublicMeetings(project().Slug || '')">
              <i class="fa-light fa-rotate-reverse" pTooltip="Refresh Meetings" tooltipPosition="left"></i>
            </button>
          </div>
        </div>
        <div class="px-2 pb-4">
          <hr class="my-2" />
        </div>
        <lfx-calendar></lfx-calendar>
        <div class="px-2 pb-4">
          <hr class="my-2" />
        </div>
        <div class="flex flex-col gap-4">
          <lfx-committee-filter></lfx-committee-filter>
          <lfx-projects-filter *ngIf="!selectedCommittee()"></lfx-projects-filter>
        </div>
      </div>
    </p-card>
  </div>
  <div class="main">
    <p-card>
      <div class="pt-4">
        <lfx-timeline [events]="meetings$ | async" [pastEvents]="pastMeetings$ | async" [date]="date()"></lfx-timeline>
      </div>
    </p-card>
  </div>
</div>
<div class="bg-[#F3F4F4] pb-4">
  <lfx-footer cookie-tracking="true"></lfx-footer>
</div>

<ng-template #loading>
  <div class="px-3">
    <p-skeleton width="100%" height="54px"></p-skeleton>
  </div>
</ng-template>
